// extracted by mini-css-extract-plugin
module.exports = {"hr":"Hr__hr___2l8Es"};